import {
  ABOUT_LIST_FETCH,
  ABOUT_LIST_SUCCESS,
  ABOUT_LIST_FAILURE
} from './actionTypes';

//import { ADD_ABOUT_TO_THE_LIST } from '../ServiceForm/actionTypes';

const initialState = {
  isLoaded: false,
  abouts: [],
  error: []
};

export const aboutsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ABOUT_LIST_FETCH:
      return { ...state, isLoaded: false };
    case ABOUT_LIST_SUCCESS:
      return { ...state, isLoaded: true, abouts: action.payload };
    /*     case ADD_ABOUT_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        abouts: [...state.abouts, action.payload]
      }; */
    case ABOUT_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.aboutList.isLoaded;
export const getAbouts = state => state.aboutList.abouts;
export const getError = state => state.aboutList.error;



// WEBPACK FOOTER //
// ./src/modules/AboutList/reducer.js